module.exports = {"title":"{{ type }} number","placeholder":"Enter your {{ type }}","example":"Example: {{ example }}","check_format":"Please double-check the format"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/taxNumber.json
// module id = 551
// module chunks = 245 949